"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getNotificationSettingsMap(channelSettings) {
    return channelSettings.reduce(function (acc, settings) {
        acc[settings.notificationType] = settings.mute;
        return acc;
    }, {});
}
exports.getNotificationSettingsMap = getNotificationSettingsMap;
function getNotificationSettingsRequest(channel, settingsMap) {
    var settings = Object.keys(settingsMap).map(function (notificationType) {
        return {
            notificationType: notificationType,
            mute: settingsMap[notificationType],
        };
    });
    return {
        channel: channel,
        settings: settings,
    };
}
exports.getNotificationSettingsRequest = getNotificationSettingsRequest;
//# sourceMappingURL=notifications.js.map